/**
 * Service Registry - Centralized service registration and accessors
 *
 * All services are registered here in ONE central file.
 * This provides tree-shakeable service imports and clean production code.
 *
 * Benefits:
 * - No imports in index.tsx (cleaner entry point)
 * - Tree-shakeable (services only bundled when used)
 * - Small bundle size (imports only service classes, not whole modules)
 * - All services visible in one file
 * - No circular dependencies
 */

import { registerService, getService } from './ServiceRegistry'

// Import ONLY service classes (not whole modules)
import AccountService from 'src/app/modules/account/services/accountService'
import MockAccountService from 'src/app/modules/account/services/MockAccountService'
import type { IAccountService } from 'src/app/modules/account/services'

// Centralized registration - add new services here
registerService('account', AccountService, MockAccountService)

// Export typed accessor functions
export const getAccountService = (): IAccountService => {
  return getService<IAccountService>('account')
}

// Export ServiceRegistry utilities for advanced usage
export { registerService, getService, resetAll, getRegisteredServices } from './ServiceRegistry'
